import React from "react";
import { HOMEPAGE_ANALYSTS } from "../constants";
import {
  StripSection,
  StripInner,
  StripTitle,
  AvatarRow,
  AvatarItem,
  AvatarWrap,
  AvatarImage,
  AvatarName,
  AvatarRole,
} from "./AnalystStrip.styles";

const AnalystStrip = () => (
  <StripSection>
    <StripInner>
      <StripTitle>
        Get access to these <span>world-class analysts</span> today
      </StripTitle>
      <AvatarRow>
        {HOMEPAGE_ANALYSTS.map((analyst) => (
          <AvatarItem key={analyst.name}>
            <AvatarWrap>
              <AvatarImage
                src={analyst.profilePic}
                alt={analyst.name}
                loading="lazy"
              />
            </AvatarWrap>
            <AvatarName>{analyst.name}</AvatarName>
            <AvatarRole>{analyst.title}</AvatarRole>
          </AvatarItem>
        ))}
      </AvatarRow>
    </StripInner>
  </StripSection>
);

export default AnalystStrip;
